class HorGallery {
    constructor() {
        gsap.registerPlugin(ScrollTrigger);

        var that = this;

        that.buildit();

        $(window).resize(function () {
            that.buildit();
        });


    }


    buildit() {
        let that = this;
        that.windowWidth = $(window).width();
        if (that.windowWidth <= 1024) {
            that.buildMobilView();
        } else {
            console.log('build desktop');
            that.buildDesktopView();
        }
    }

    buildMobilView() {

    }

    buildDesktopView() {
        let sections = gsap.utils.toArray(".el-hor--section");
        if (sections.length > 0) {
            let containers = document.getElementsByClassName('el-hor--wrapper');
            for (let i = 0; i < containers.length; i++) {
                let container = containers[i];

                let gallery_id = container.getAttribute('data-hor-wrapper');
                let gallery_title = $("[data-hor-title='" + gallery_id + "']");

                let scroll_config = {};

                if (container.classList.contains('el-hor--wrapper--full')) {
                    console.log('1');
                    scroll_config = {
                        trigger: container,
                        invalidateOnRefresh: true,
                        pin: true,
                        scrub: 1,
                        start: "top top", // when the top of the trigger hits the top of the viewport
                        //end: 'top top', // end after scrolling this distance
                        //end: () => "+=" + container.offsetWidth
                        end: () => (container.offsetWidth - innerWidth)
                    };
                } else {
                    console.log('2');
                    scroll_config = {
                        trigger: container,
                        invalidateOnRefresh: true,
                        pin: true,
                        scrub: 1,
                        start: "top 30%",
                        toggleActions: "restart pause reverse pause",
                        onEnter: (e) => {
                            console.log('enter');
                            if (gallery_title.length > 0) {
                                gallery_title.addClass('opacity');
                            }
                        },
                        onLeave: (e) => {
                            console.log('leave');
                            if (gallery_title.length > 0) {
                                gallery_title.removeClass('opacity');
                            }
                        },
                        //end: "top top"
                        end: () => "+=" + (container.offsetWidth - innerWidth)
                        //start: "top top", // when the top of the trigger hits the top of the viewport
                        //end: 'top top', // end after scrolling this distance
                        //end: () => "+=" + container.offsetWidth
                        //end: () => container.scrollWidth - document.documentElement.clientWidth + container.offsetWidth
                    };
                }

                gsap.to(container, {
                    x: () => -(container.offsetWidth - innerWidth) + "px",
                    ease: "none",
                    scrollTrigger: scroll_config
                });
                $(".el-hor--nav a").on("click", function (event) {
                    event.preventDefault();
                    var id = $(this).attr('href');
                    var left = $(id)[0].offsetLeft;
                    console.log(left);
                    gsap.to(window, {
                        scrollTo: (left * (container.offsetWidth / (container.offsetWidth - window.innerWidth))),
                        autoKill: false,
                        duration: 1.5
                    });
                });


                if (!!window.IntersectionObserver) {

                    let hor_sections;
                    let options = {
                        rootMargin: '0px 0px 0px 0px'
                    };
                    hor_sections = document.querySelectorAll(".el-hor--section");
                    const headlineServer = new IntersectionObserver(function (entries, observer) {
                        entries.forEach(function (entry) {

                            if (entry.isIntersecting) {
                                entry.target.classList.add("lazy");
                            }
                        }, options);
                    });
                    hor_sections.forEach(function (hor_section) {
                        headlineServer.observe(hor_section);
                    });
                }
            }


        }
    }

}
